

const ACTIVTIY_FEED_FETCH_INTERVAL = 30_000;

const MINIMUM_EVENT_AGE = 30_000

export { ACTIVTIY_FEED_FETCH_INTERVAL, MINIMUM_EVENT_AGE };